
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import api from "@/api";
import { TenantSettingsEditDto } from "../../../api/appService";

@Component
export default class Calc extends Vue {
  form: TenantSettingsEditDto = {
    oss: {
      bucketName: "",
      domainHost: "",
      userName: "",
      password: ""
    },
    client: {},
    notify: {}
  };

  created() {
    this.fetchData();
  }

  async fetchData() {
    await api.tenantSetting
      .getAllSettings()
      .then(res => {
        this.form = res;
      })
      .finally(() => {});
  }

  async onSubmit() {
    await api.tenantSetting
      .updateAllSettings({
        body: this.form
      })
      .then(res => {
        this.$message.success("更新成功!");
      });
    await this.fetchData();
  }
  onCancel() {
    this.$message({
      message: "cancel!",
      type: "warning"
    });
  }
}
